module.exports = __webpack_public_path__ + "static/but-what-if-were-wrong-b87e6c293723494247d1f863c90c5f1b.jpg";